import type { GroupFragment } from "@/graphql";
import type { IMultiSelectItem, IOption } from "@/interfaces";

const toMultiSelectItem = (item: GroupFragment): IMultiSelectItem => {
  return {
    id: item.id,
    title: item.name,
    svg: "fas-users",
    iconBackground: item.color || undefined,
    svgStyle: "circle",
  };
};

const toOption = (item: GroupFragment): IOption => {
  return {
    value: item.id,
    title: item.name,
  };
};

export default {
  toMultiSelectItem,
  toOption,
};
